import { demoGraphs, type DemoAudience, type DemoCategory } from '../../data/demoGraphs';

/** localStorage: officer chose to expand the full demo catalog. */
export const DASHBOARD_SHOW_ALL_DEMOS_KEY = 'cryptoflow.dashboard.showAllDemos';

export type DemoCatalogScenario = {
    id: string;
    demo: string;
    title: string;
    description: string;
    address: string;
    chain: string;
    upi?: string;
    tags: string[];
    category: DemoCategory;
    priority: boolean;
    startHereOrder?: number;
    startHereBlurb?: string;
    startHereDuration?: string;
    demoType?: DemoAudience;
};

export function listDemoScenarios(): DemoCatalogScenario[] {
    return Object.values(demoGraphs)
        .filter((d) => d.category)
        .map((d) => ({
            id: d.id,
            demo: d.id,
            title: d.title,
            description: d.description || '',
            address: d.realAddress || d.address || '',
            chain: d.realChain || d.chain || 'ETH',
            upi: d.upi,
            tags: d.tags || [],
            category: d.category as DemoCategory,
            priority: d.priority || false,
            startHereOrder: d.startHereOrder,
            startHereBlurb: d.startHereBlurb,
            startHereDuration: d.startHereDuration,
            demoType: d.demoType,
        }));
}

export function workbenchHrefForDemo(
    scenario: {
        demo?: string;
        upi?: string;
        chain: string;
        address: string;
    },
    opts?: { guest?: boolean },
): string {
    const base = opts?.guest ? '/demo/workbench' : '/workbench';
    const demoParam = scenario.demo ? `demo=${encodeURIComponent(scenario.demo)}` : '';
    if (scenario.upi) {
        const q = `upi=${encodeURIComponent(scenario.upi)}`;
        return demoParam ? `${base}?${q}&${demoParam}` : `${base}?${q}`;
    }
    const q = `chain=${encodeURIComponent(scenario.chain)}&address=${encodeURIComponent(scenario.address)}`;
    return demoParam ? `${base}?${q}&${demoParam}` : `${base}?${q}`;
}

export function isFeaturedDashboardDemo(s: {
    priority?: boolean;
    startHereOrder?: number | null;
}): boolean {
    return Boolean(s.priority) || s.startHereOrder != null;
}

export function splitDemoCatalog<T extends { priority?: boolean; startHereOrder?: number | null }>(
    scenarios: T[],
    showAll: boolean,
): { visible: T[]; hiddenCount: number } {
    if (showAll) return { visible: scenarios, hiddenCount: 0 };
    const featured = scenarios.filter(isFeaturedDashboardDemo);
    return { visible: featured, hiddenCount: scenarios.length - featured.length };
}
